import { ElementTypes } from '@components/Studio/QueryCreationTwo/ActionButtons/utils';
import { IQuestionFilterItem } from '../constants/queryCreation.interface';

export type filterDepsType = Record<string, Record<string, Record<string, boolean>>>;

const getBase = (acc: filterDepsType, filter: IQuestionFilterItem) => {
  // account for the property concept/prop OR the calculation being used
  const concept = filter?.elementProps?.concept || filter?.elementProps?.calcId || '';
  const prop = filter?.elementProps?.property || filter?.elementProps?.label || '';
  const aggrType = filter?.elementProps?.aggrType || '';

  const propertyDep =
    filter.elementType === ElementTypes.isProp || filter.elementType === ElementTypes.isCalc
      ? {}
      : { [aggrType]: true };
  const existingPropertyDeps = acc?.[concept]?.[prop] || {};

  return {
    ...acc,
    [concept]: {
      ...(acc?.[concept] || {}),
      [prop]: {
        ...existingPropertyDeps,
        ...propertyDep,
      },
    },
  };
};

const recurseChildren = (filters: IQuestionFilterItem[], deps: filterDepsType): filterDepsType => {
  return filters.reduce((filtersAcc, filter) => {
    if (filter.children && filter.children.length > 0) {
      return {
        ...filtersAcc,
        ...recurseChildren(filter.children, filtersAcc),
      };
    } else {
      return getBase(filtersAcc, filter);
    }
  }, deps);
};

const getFilterPropDeps = (questionWideFilters: IQuestionFilterItem[]): filterDepsType => {
  try {
    let deps = questionWideFilters.reduce((acc: filterDepsType, filter: IQuestionFilterItem) => {
      if (filter.children && filter.children.length > 0) {
        return {
          ...acc,
          ...recurseChildren(filter.children || [], acc),
        };
      } else {
        return getBase(acc, filter);
      }
    }, {});

    return deps;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export default getFilterPropDeps;
